import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { RequireAdmin } from '../components/RequireAdmin.tsx';
import { SyncStatusPanel } from '../features/admin/SyncStatusPanel.tsx';

export const Route = createFileRoute('/admin/sync')({
  component: AdminSyncPage,
});

function AdminSyncPage() {
  return (
    <RequireAdmin>
      <SyncView />
    </RequireAdmin>
  );
}

function SyncView() {
  return (
    <>
      <Helmet>
        <title>Sync · Admin · VEX Teams Atlas</title>
      </Helmet>
      <div className="mx-auto w-full max-w-5xl px-4 py-10 md:py-14">
        <header className="mb-8 flex flex-col gap-2">
          <p className="text-2xs uppercase tracking-[0.32em] text-fg-subtle">Admin</p>
          <h1 className="font-display text-3xl tracking-tight text-fg md:text-4xl">
            Sync status
          </h1>
          <p className="max-w-prose text-sm text-fg-muted">
            Most syncs run on cron triggers. Use the buttons below to kick off a manual run.
          </p>
        </header>

        <SyncStatusPanel />
      </div>
    </>
  );
}
